import React, { useState } from "react";
import {
  Paper,
  Box,
  IconButton,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import MyTitle from "../../components/CardSection/MyTitle";
import { functions } from "../../config/firebaseConfig";
import { httpsCallable } from "firebase/functions";

const QuinItemAdd = () => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [prix, setPrix] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleAdd = async () => {
    if (!name || !prix) return;
    setStatus("saving");
    setMessage("");
    try {
      const add = httpsCallable(functions, "quinAddItem");
      const result = await add({ name: name.trim(), prix: prix.trim() });
      setMessage(`Ajouté avec ID : ${result.data.id}`);
      setStatus("saved");
      setName("");
      setPrix("");
    } catch (e) {
      setStatus("error");
      setMessage("Erreur lors de l'ajout");
    }
  };

  return (
    <Paper elevation={0} variant="outlined" sx={{ mt: 2, p: 1 }}>
      <Box
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          borderRadius: 1,
          p: 0.5,
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <MyTitle text="AJOUTER ARTICLE" />
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((v) => !v);
          }}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      {open && (
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 0.5, px: 1.5, pb: 1 }}
        >
          <TextField
            size="small"
            fullWidth
            label="Nom"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setStatus("idle");
              setMessage("");
            }}
          />
          <TextField
            size="small"
            fullWidth
            label="Prix (CDF)"
            value={prix}
            placeholder="7,08"
            onChange={(e) => {
              setPrix(e.target.value);
              setStatus("idle");
              setMessage("");
            }}
          />
          <Button
            variant="contained"
            color="success"
            onClick={handleAdd}
            disabled={!name || !prix || status === "saving"}
          >
            {status === "saving" ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Ajouter"
            )}
          </Button>

          {message && (
            <Typography
              variant="body2"
              color={status === "saved" ? "success.main" : "error"}
            >
              {message}
            </Typography>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default QuinItemAdd;
